<template>
  <div class="skeleton h-4" :class="animationName" />
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    animation?: string;
  }>(),
  {
    animation: "shimmer",
  },
);

const animationName = computed(() => [
  props.animation ? `skeleton--${props.animation}` : undefined,
]);
</script>

<style lang="scss">
.skeleton {
  @apply inline-block w-full select-none bg-neutral-200 align-middle;

  &--shimmer {
    &:after {
      content: "";
    }

    @apply relative overflow-hidden after:absolute after:bottom-0 after:left-0 after:right-0 after:top-0 after:-translate-x-full after:animate-shimmer after:[background:linear-gradient(90deg,_rgba(0,0,0,0)_0%,rgba(255,255,255,1)_40%,rgba(255,255,255,1)_60%,rgba(0,0,0,0)_100%)];
  }
}
</style>
